module.exports = __webpack_public_path__ + "img/rodape1.161cd405.png";